import axios from "axios";

const loginedApi = axios.create({

  baseURL: "https://www.connect2mydoctor.com/c2mydrrestganga/v1/c2mdapi/",
  //baseURL: "https://uat.c2mdr.com/c2mydrrestganga/v1/c2mdapi/", //changed for uat
  //baseURL: "https://uat.c2mdr.com/c2mydrrestprodganga/v1/c2mdapi/", //changed for interbranch

    //baseURL: "https://www.connect2mydoctor.com/c2mydrrestganga/v1/c2mdapi/",
   //baseURL: "https://uat.c2mdr.com/c2mydrrestganga/v1/c2mdapi/", //changed for uat
 // baseURL: "https://uat.c2mdr.com/c2mydrrestganga/v1/c2mdapi/", //changed for interbranch

  timeout: 1500000, // Set timeout to 15 seconds (in milliseconds)
  // baseURL: "http://localhost:8080/c2mydrrestuat/v1/c2mdapi/",
});

export default loginedApi;

// export const SERVER_API_URL = "http://localhost:8080/c2mydrrestuat/v1/c2mdapi"

 //export const SERVER_API_URL = "https://uat.c2mdr.com/c2mydrrestprodganga/v1/c2mdapi/"; //changed for demo
// export const SERVER_API_URL ="https://uat.c2mdr.com/c2mydrrestganga/v1/c2mdapi/";
export const SERVER_API_URL ="https://www.connect2mydoctor.com/c2mydrrestganga/v1/c2mdapi/";


// export const TestingUrl ="https://www.connect2mydoctor.com/testcomputer.html";


export const TestingUrl = "https://zoom.us/test";


//export const FILEURL = "https://uat.c2mdr.com/gangaprod/Connect2MyDoctorRequest";
 export const FILEURL =  "https://www.connect2mydoctor.com/ganga/Connect2MyDoctorRequest";
export const c2mdApi = axios.create({
  //baseURL: "https://uat.c2mdr.com/c2mydrrestprodganga/v1/c2mdapi/", // demo
  //baseURL: "https://uat.c2mdr.com/c2mydrrestganga/v1/c2mdapi/", //changed for uat
   baseURL: "https://www.connect2mydoctor.com/c2mydrrestganga/v1/c2mdapi/",

});

export const c2mdApinew = axios.create({
  baseURL: "http://localhost:8080/ROOT/",
});
